import { create } from 'zustand';
import apiClient from '../utils/apiClient';
import { useAuthStore } from './authStore';

export const useRoleStore = create((set, get) => ({
  roles: [],
  isLoading: false,
  error: null,
  fetchRoles: async (isAuthenticated = false, token = null) => {
    
    set({ isLoading: true, error: null });
    console.log('[roleStore] fetchRoles called');
    try {
      const roles = await apiClient.get('/role-list');
      if (Array.isArray(roles) && roles.length > 0) {
        set({ roles, isLoading: false });
        console.log('[roleStore] global role list set:', roles, new Error().stack);
      } else {
        console.warn('[roleStore] fetchRoles received null/empty roles, not updating store:', roles);
      }
      return roles;
    } catch (error) {
      set({ error: error.message || 'Failed to fetch roles', isLoading: false });
      console.error('[roleStore] Error fetching roles:', error);
      
      return [];
    }
  },
  // Add a clearRoles method that can be called during logout
  clearRoles: () => {
    set({ roles: [], error: null, isLoading: false });
    console.log('[roleStore] roles cleared by clearRoles');
  }
}));
